import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { GridSelect } from "../../components/InputComponents";
import Pagebar from "../../components/Pagebar";
import { getOptionTypes, fetchData, sortJSONDESC } from "../../js/main";

export default function Summary() {
  const [state, setState] = useState();
  const [options, setOptions] = useState({});
  const [employees, setEmployees] = useState();
  useEffect(() => {
    (async () => {
      let result = await getOptionTypes([
        "hr_division",
        "hr_work_status",
        "hr_professional_type",
      ]);
      result.hr_division.unshift({ label: "ทั้งหมด" });
      result.hr_professional_type.unshift({ label: "ทั้งหมด" });
      setOptions(result);
      let state = {
        division: result.hr_division[0] ? result.hr_division[0].label : "-",
        status: result.hr_work_status[0] ? result.hr_work_status[0].label : "-",
        license: result.hr_professional_type[0]
          ? result.hr_professional_type[0].label
          : "-",
        limit: 100,
        skip: 0,
      };
      setState(state);
    })();
  }, []);
  useEffect(() => {
    (async () => {
      if (state) {
        let match = { $and: [] };
        if (state.division !== "ทั้งหมด")
          match["$and"].push({ division: state.division });
        match["$and"].push({ work_status: state.status });
        if (state.license !== "ทั้งหมด")
          match["$and"].push({ "licenses.qualified_name": state.license });
        let query = {
          match,
          collection: "employees",
          limit: state.limit,
          skip: state.skip || 0,
          sort: { first_name: 1, last_name: 1 },
        };
        let result = await fetchData(query);
        for (let emp of result.result) {
          if (emp.contracts[0]) {
            let current_contract = await sortJSONDESC(emp.contracts);
            emp.current_contract = current_contract[0];
          } else emp.current_contract = {};
        }
        setEmployees(result);
      }
    })();
  }, [state]);

  return (
    <div>
      {state && employees && (
        <>
          <Grid container spacing={1}>
            <GridSelect
              grid={[12, 12, 6, 5]}
              options={options.hr_division}
              label="Select division"
              size="small"
              onChange={(val) => setState({ ...state, division: val, skip: 0 })}
              value={state.division}
              disabled_empty={true}
            />
            <GridSelect
              grid={[12, 12, 3, 3]}
              options={options.hr_work_status}
              label="Select status"
              size="small"
              onChange={(val) => setState({ ...state, status: val, skip: 0 })}
              value={state.status}
              disabled_empty={true}
            />
            <GridSelect
              grid={[12, 12, 3, 4]}
              options={options.hr_professional_type}
              label="Select license"
              size="small"
              onChange={(val) => setState({ ...state, license: val, skip: 0 })}
              value={state.license}
              disabled_empty={true}
            />
            <Grid item xs={12} sm={12} md={7} style={{ marginTop: "10px" }}>
              <Pagebar
                count={Math.floor(employees.count / state.limit) + 1}
                page={state.skip / state.limit + 1}
                changePage={(val) => {
                  setState({ ...state, skip: (val - 1) * state.limit });
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={5}
              align="right"
              style={{ fontWeight: 500, marginTop: "10px" }}
            >
              Result : {employees.count} Person(s)
            </Grid>
          </Grid>

          <EmployeeTable employees={employees} />
        </>
      )}
    </div>
  );
}

function EmployeeTable({ employees }) {
  return (
    <div style={{ paddingTop: "10px" }}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "80px" }}>
                ลำดับ
              </TableCell>
              <TableCell align="center" style={{ width: "100px" }}>
                รหัส
              </TableCell>
              <TableCell align="center">ชื่อ - สกุล</TableCell>
              <TableCell align="center" style={{ width: "120px" }}>
                ชื่อเล่น
              </TableCell>
              <TableCell align="center">แผนก</TableCell>
              <TableCell align="center">ประเภทการบรรจุ</TableCell>
              <TableCell align="center" style={{ width: "120px" }}>
                วันที่ลาออก
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.count === 0 && (
              <TableRow>
                <TableCell
                  colSpan={7}
                  align="center"
                  style={{ color: "#999", lineHeight: "60px" }}
                >
                  ไม่พบข้อมูล
                </TableCell>
              </TableRow>
            )}
            {employees.result &&
              employees.result.map((emp, key) => (
                <TableRow key={key}>
                  <TableCell align="center">
                    {employees.skip + key + 1}
                  </TableCell>
                  <TableCell align="center">{emp.employee_id}</TableCell>
                  <TableCell>
                    {emp.prefix} {emp.first_name} {emp.last_name}
                  </TableCell>
                  <TableCell align="center">{emp.nickname}</TableCell>
                  <TableCell align="center">{emp.division}</TableCell>
                  <TableCell align="center">
                    {emp.current_contract.contract_type}
                  </TableCell>
                  <TableCell align="center">{emp.resign_date}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
